// src/components/Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md py-4 px-6 sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between">
        {/* Logo */}
        <h1 className="text-2xl font-bold text-blue-800">Dr. Ashweeja Nagesh</h1>

        {/* Hamburger Menu Button */}
        <button
          className="md:hidden text-blue-800 focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
            />
          </svg>
        </button>

        {/* Navigation Links */}
        <nav
          className={`${
            isMenuOpen ? 'block' : 'hidden'
          } md:flex space-y-4 md:space-y-0 md:space-x-6 text-blue-700 text-lg`}
        >
          <Link to="/" className="hover:text-blue-900 transition block md:inline">
            Home
          </Link>
          <Link to="/blog" className="hover:text-blue-900 transition block md:inline">
            Blog
          </Link>
          <Link to="/book-appointment" className="hover:text-blue-900 transition block md:inline">
            Appointment
          </Link>
          <Link to="/reviews" className="hover:text-blue-900 transition block md:inline">
            Reviews
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
